package com.wintermar.inspection.feature.util.expect_init

actual suspend fun processAfterSuccessStartInspection(
    onCreateLocalData: suspend () -> Unit,
    onGoToInspectionAnswer: suspend () -> Unit
) {
    onGoToInspectionAnswer()
}
